const chn = {
    translation: {
        // Trucks 
        "title": "卡车运输",
        "intro": {
            "main_text": "成功的保障",
            "text_1": "在 MMSH 物流公司，我们深知全球范围内对可靠高效的公路货运服务的需求持续增长。我们的卡车运输服务提供灵活的调度安排，不受港口、机场或火车站的限制。在制定定制化解决方案并规划最佳路线之前，我们经验丰富的物流团队会仔细评估每一个请求。我们尊重客户的时间，因此采用最新的 GPS 和 GLONASS 技术来跟踪货物。"
        },
        "more_info": "更多信息",
        "projects": {
            "title": "已完成的项目",
            "items": [
            { "title": "全球司机短缺问题。" },
            { "title": "为您提供数字化解决方案。" },
            { "title": "新的海运航线。" },
            { "title": "土耳其地震影响。" }
            ]
        },
        "completed_projects": {
            "title": "已完成的项目",
            "items": [
            { "title": "新的港口已准备为您服务。" },
            { "title": "商业保障。" },
            { "title": "我们的船只已开始与美国合作。" }
            ]
        },
        // Trucks
        // Trains
        "title_2": "铁路运输",
        "intro_2": {
            "main_text_2": "铁路货运的快速交付",
            "text_1": "在 MMSH 物流公司，我们认识到对快速、经济高效且环保的铁路货运解决方案的需求不断增长。我们的铁路运输服务提供无缝对接的大容量货运，确保高效且可持续的物流方案。在设计定制物流计划之前，我们的专家团队会仔细评估每个请求，优化路线以最大限度地提高速度并降低成本。通过 GPS 和 GLONASS 等先进跟踪技术，我们提供实时货物可视化，让客户对每一公里的运输充满信心。"
        },
        "projects_2": {
            "title": "已完成的项目",
            "items": [
            { "title": "我们的服务数字化。" },
            { "title": "与欧洲的贸易增加。" },
            { "title": "来自日本的新列车已就位。" },
            { "title": "员工薪资增长。" }
            ]
        },
        "completed_projects_2": {
            "title": "已完成的项目",
            "items": [
            { "title": "在俄亥俄州推出新办公室。" },
            { "title": "现在，货物运输更快了。" },
            { "title": "加强与北京的贸易关系。" },
            { "title": "使用我们的新移动应用进行物流管理。" }
            ]
        },
        // Trains
        // Air
        "title_3": "空运",
        "intro_3": {
            "main_text_3": "快速可靠的空运解决方案",
            "text_1": "凭借广泛的国际航空承运人网络，我们为各类企业提供灵活的调度安排、优先处理和定制化的物流解决方案。无论是紧急货物、高价值货物还是温度敏感型货物，我们都确保以最高的安全标准和专业照护进行运输。通过 GPS 和先进的物流系统等实时跟踪技术，我们提供从起飞到到达的全程货物可视化管理。我们的专业团队优化运输路线，以实现最大化的效率和成本节约，为客户带来无缝的空运体验。与 MMSH 物流公司合作，世界近在咫尺。速度至关重要，我们为您交付。"
        },
        "projects_3": {
            "title": "已完成的项目",
            "items": [
            { "title": "与 MMSH 建立可靠的合作伙伴关系。" },
            { "title": "最快速的跨洲交付服务。" },
            { "title": "通过空运实现经济高效的货物运输。" }
            ]
        },
        "completed_projects_3": {
            "title": "已完成的项目",
            "items": [
            { "title": "与国际公司建立合作关系。" },
            { "title": "我们已开始与南美洲合作。" }
            ]
        },
        // Air
        // Boats
        "title_4": "海运",
        "intro_4": {
            "main_text_4": "无缝可靠的海运解决方案",
            "text_1": "凭借广泛的全球航运承运人和港口网络，我们为各类企业提供灵活的调度安排、安全处理和量身定制的物流解决方案。无论是大宗货物、超大设备还是温控货物，我们都确保在国际水域内安全高效地运输。通过 GPS、AIS（自动识别系统）和卫星监控等先进跟踪技术，我们提供从港口到港口的实时货物可视化管理。我们的专家团队优化运输路线，以缩短运输时间并降低成本，确保顺畅和准时的交付。"
        },
        "projects_4": {
            "title": "已完成的项目",
            "items": [
            { "title": "新的港口已对外开放贸易。" },
            { "title": "完善的安全管理计划。" },
            { "title": "舒适的海上运输体验。" }
            ]
        },
        "completed_projects_4": {
            "title": "已完成的项目",
            "items": [
            { "title": "与香港港口建立合作关系。" },
            { "title": "通过 MMSH 实现快速运输。" }
            ]
        },
        // Boats
        // Multimodal
        "title_5": "多式联运",
        "intro_5": {
            "main_text_5": "集成高效的多式联运货运解决方案",
            "text_1": "结合空运、海运、公路和铁路运输的优势，我们提供无缝的多式联运物流解决方案，以满足您的业务需求。我们的灵活调度和安全处理确保货物在各国和大陆间高效运输。无论是集装箱货物、超大设备还是温控货物，我们优化路线以减少运输时间和成本。借助 GPS、AIS 和卫星监控等先进跟踪技术，我们在每个阶段提供实时可视化。我们的专家团队确保各运输模式间顺畅协调，实现及时且具有成本效益的交付。"
        },
        "projects_5": {
            "title": "已完成的项目",
            "items": [
            { "title": "全球贸易航线扩展。" },
            { "title": "AI 驱动系统的实施。" },
            { "title": "优化多式联运货运解决方案。" },
            { "title": "可持续航运实践的发展。" }
            ]
        },
        "completed_projects_5": {
            "title": "已完成的项目",
            "items": [
            { "title": "与香港港口建立战略联盟。" },
            { "title": "MMSH 快捷服务实现更快速的物流。" }
            ]
        },
        // Multimodal
        // Chemicals
        "title_6": "化学品运输",
        "intro_6": {
            "main_text_6": "安全、高效且合规的化学品物流",
            "text_1": "MMSH 物流公司专注于化学品运输的安全与高效，确保完全符合国际安全法规。我们的多式联运解决方案涵盖公路、海运、铁路和航空，为危险和非危险化学品提供无缝运输。我们与行业领导者合作，提供安全处理、温控存储及专业运输方式。我们的专家团队管理所有必要的文件和合规要求，确保顺利清关和符合国际市场监管标准。通过先进的跟踪技术，我们在整个供应链中提供完整的可视化管理，确保可靠且具有成本效益的化学品物流方案。"
        },
        "projects_6": {
            "title": "化学品货运解决方案的进步",
            "items": [
            { "title": "全球化学品运输线路扩展。" },
            { "title": "AI 驱动的危险品跟踪系统。" },
            { "title": "优化化学品多式联运物流。" },
            { "title": "化学品运输的环保解决方案。" }
            ]
        },
        "completed_projects_6": {
            "title": "已完成的项目",
            "items": [
            { "title": "欧洲新建化学品物流枢纽。" },
            { "title": "AI 驱动的安全合规监控系统。" }
            ]
        },
        // Chemicals
        // Technology
        "title_9": "科技行业物流",
        "intro_9": {
            "main_text_9": "安全高速的科技行业物流",
            "text_1": "MMSH 物流公司为高价值科技产品（包括电子产品、半导体和数据服务器）提供定制化运输解决方案。我们深知科技行业不仅需要快速交付，还需要高度安全且受控的运输环境，以保护敏感组件。我们的物流网络确保安全处理、实时监控和加快运输，满足准时制造和分销需求。通过 AI 驱动的跟踪和多式联运解决方案，我们减少运输时间和运营成本，使企业优化供应链效率。无论是紧急空运还是安全集装箱运输，我们都提供可定制的解决方案，以满足您的需求。"
        },
        "projects_9": {
            "title": "科技货运解决方案的进展",
            "items": [
            { "title": "扩展电子产品的安全仓库。" },
            { "title": "用于实时货物跟踪的物联网传感器。" },
            { "title": "优化半导体供应链物流。" },
            { "title": "高价值货物的高级安全措施。" }
            ]
        },
        "completed_projects_9": {
            "title": "已完成的项目",
            "items": [
            { "title": "建立全球半导体物流安全网络。" },
            { "title": "AI 驱动的敏感科技货物监控系统。" }
            ]
        },
        // Technology
        // Groceries
        "title_10": "食品物流",
        "intro_10": {
            "main_text_10": "快速新鲜的食品供应链物流",
            "text_1": "MMSH 物流公司为食品配送提供温控和时间敏感的运输解决方案。我们专注于新鲜农产品、乳制品、肉类、冷冻食品和干货的配送，确保易腐货物从农场到商店的全程保持高质量。我们的先进冷链物流包括气候控制存储、实时温度监控和快速配送网络。无论是大型超市分销还是本地市场的小批量配送，我们优化供应链，防止食品损坏，减少浪费，并提高效率。通过多式联运方式，包括冷藏卡车运输、空运和快速末端配送，我们确保食品的新鲜度、可靠性，并符合食品安全法规。"
        },
        "projects_10": {
            "title": "食品物流的创新",
            "items": [
            { "title": "扩展冷藏运输车队。" },
            { "title": "AI 驱动的供应链优化。" },
            { "title": "用于延长货架期的先进包装技术。" },
            { "title": "有机食品的可持续物流方案。" }
            ]
        },
        "completed_projects_10": {
            "title": "已完成的项目",
            "items": [
            { "title": "建立食品物流的温控网络。" },
            { "title": "集成 AI 驱动的生鲜产品需求预测系统。" }
            ]
        },
        // Groceries
        // Pharmaceuticals
        "title_11": "医药物流",
        "intro_11": {
            "main_text_11": "温控合规的医药物流解决方案",
            "text_1": "MMSH 物流公司专注于医药运输，确保温度敏感的药品、疫苗和医疗用品安全高效地送达目的地。我们采用先进的冷链物流技术，实时监控温度，确保符合 WHO 和 GDP 规定。我们的团队经过专业培训，以极高的标准处理医药产品，为医院、药房和医疗分销商提供无风险运输解决方案。从温控存储到快速最后一公里配送，我们确保关键的医疗产品在最佳条件下运输，最大限度地减少风险和延误。"
        },
        "projects_11": {
            "title": "医药货运解决方案的进展",
            "items": [
            { "title": "扩展温控仓库网络。" },
            { "title": "基于区块链的医疗追踪系统。" },
            { "title": "AI 驱动的疫苗运输物流。" },
            { "title": "紧急医疗物资运输解决方案。" }
            ]
        },
        "completed_projects_11": {
            "title": "已完成的项目",
            "items": [
            { "title": "跨大陆安全疫苗分发。" },
            { "title": "AI 驱动的医药物流风险管理系统。" }
            ]
        },
        // Pharmaceuticals
        // Fashion
        "title_12": "时尚物流",
        "intro_12": {
            "main_text_12": "快速灵活的时尚行业物流",
            "text_1": "MMSH 物流公司为时尚行业提供定制化货运解决方案，确保纺织品、服装和配饰的及时高效运输。我们深知时尚行业需要速度和精准度，以适应季节性趋势和快速变化的市场需求。我们的网络包括快速空运、专用卡车运输和高效仓储，支持时尚品牌按时向全球市场交付产品。通过智能库存管理和 AI 驱动的需求预测，我们帮助企业优化供应链，减少库存过剩，并通过环保运输方案提升可持续性。"
        },
        "projects_12": {
            "title": "时尚物流的进展",
            "items": [
            { "title": "扩展全球时尚分销网络。" },
            { "title": "服装运输的实时跟踪系统。" },
            { "title": "优化快速时尚供应链管理。" },
            { "title": "可持续品牌的环保物流方案。" }
            ]
        },
        "completed_projects_12": {
            "title": "已完成的项目",
            "items": [
            { "title": "季节性时尚产品的快速物流方案。" },
            { "title": "AI 驱动的服装品牌需求预测系统。" }
            ]
        },
        // Fashion
        // Agricultural
        "title_13": "农业物流",
        "intro_13": {
            "main_text_13": "可靠可持续的农业物流解决方案",
            "text_1": "MMSH 物流公司专注于农业产品的运输，包括谷物、新鲜农产品、化肥和牲畜饲料。我们综合的物流网络确保高效的从农场到市场的配送，支持食品生产商、批发商和出口商。通过温控运输、专业散装货运和准时配送，我们减少损耗并缩短运输时间。我们采用多式联运方式（公路、铁路、海运、空运），为季节性作物和易腐产品提供灵活的运输选择。借助 AI 驱动的需求预测和区块链可追溯性技术，我们优化供应链并确保符合全球食品安全标准。从本地农业合作社到大规模农业出口商，MMSH 物流公司提供创新且环保的物流解决方案。"
        },
        "projects_13": {
            "title": "农业物流的进展",
            "items": [
            { "title": "扩展易腐农产品的冷链运输。" },
            { "title": "AI 驱动的农业库存预测系统。" },
            { "title": "优化大宗粮食出口的多式联运物流。" },
            { "title": "有机食品的环保包装解决方案。" }
            ]
        },
        "completed_projects_13": {
            "title": "已完成的项目",
            "items": [
            { "title": "建立农场到市场的快速配送网络。" },
            { "title": "集成区块链技术进行供应链可追溯管理。" }
            ]
        },
        // Agricultural
        // Construction
        "title_14": "建筑物流",
        "intro_14": {
            "main_text_14": "重型高效的建筑行业物流",
            "text_1": "MMSH 物流公司专注于建筑材料运输，包括水泥、钢材、木材、重型机械和预制结构。我们的物流解决方案支持大型基础设施项目、住宅开发和商业建设，确保关键材料的准时交付并降低成本。我们利用专业的重型卡车运输、散装铁路货运和多式联运方式，处理超大件和重量敏感的货物。我们的物流专家提供准时交付协调，帮助建筑工地减少存储成本并保持项目进度。从原材料到高科技模块化建筑，MMSH 物流公司优化供应链，减少延误，并确保符合国际法规。"
        },
        "projects_14": {
            "title": "建筑物流的进展",
            "items": [
            { "title": "扩展专业重型运输车队。" },
            { "title": "AI 驱动的施工现场物流管理。" },
            { "title": "优化预制结构的多式联运物流。" },
            { "title": "建筑材料的可持续供应链解决方案。" }
            ]
        },
        "completed_projects_14": {
            "title": "已完成的项目",
            "items": [
            { "title": "为大型基础设施项目开发准时物流体系。" },
            { "title": "集成数字化追踪系统进行大宗建材运输。" }
            ]
        },
        // Construction
        // Bulk
        "title_15": "散装货物运输",
        "intro_15": {
            "main_text_15": "可靠且经济高效的散装货物物流",
            "text_1": "MMSH 物流公司专注于散装货物运输，包括原材料、矿产、农产品和工业品。我们在干散货、液体散货和件杂货运输方面的专业知识，确保大批量货物能够高效流通于全球贸易航线。我们利用专业船舶、散货运输船和铁路货运网络，优化成本效益和运输时间。凭借专属港口设施、自动化货物处理系统和实时跟踪技术，我们为高需求行业提供无缝物流解决方案。我们的定制散装货运策略帮助企业降低存储成本、优化供应链，并通过环保运输方式提升可持续性。"
        },
        "projects_15": {
            "title": "散装货运物流的进展",
            "items": [
            { "title": "扩展全球贸易的散货运输船队。" },
            { "title": "AI 驱动的装卸作业优化。" },
            { "title": "在港口集成自动化散货处理系统。" },
            { "title": "散装货物运输的可持续物流解决方案。" }
            ]
        },
        "completed_projects_15": {
            "title": "已完成的项目",
            "items": [
            { "title": "开发散装货物运输的多式联运解决方案。" },
            { "title": "集成数字跟踪，实现实时散装货物运输可视化。" }
            ]
        },
        // Bulk
        // Expensive Cargo
        "title_16": "贵重货物运输",
        "intro_16": {
            "main_text_16": "安全专业的高价值货物物流",
            "text_1": "MMSH 物流公司为高价值及敏感货物（包括奢侈品、珠宝、电子产品、艺术品和金融资产）提供高端运输解决方案。我们深知在运输贵重货物时，安全性、机密性和效率至关重要。我们的物流服务包括装甲运输、温控存储和专属安保护送，以确保货物在运输过程中的最高保护。借助最先进的跟踪技术、生物识别访问控制和 AI 风险评估，我们最大限度地减少运输风险并增强货物可视化管理。无论是运输珍稀收藏品、机密文件，还是奢侈时尚产品，MMSH 物流公司都提供量身定制的安全保障方案。"
        },
        "projects_16": {
            "title": "高价值货物物流的进展",
            "items": [
            { "title": "扩展奢侈品安全物流网络。" },
            { "title": "AI 驱动的高价值货运风险分析。" },
            { "title": "集成生物识别安保系统用于仓库访问控制。" },
            { "title": "优化贵重货物的多式联运物流方案。" }
            ]
        },
        "completed_projects_16": {
            "title": "已完成的项目",
            "items": [
            { "title": "建立全球珠宝运输安全路线。" },
            { "title": "开发电子产品的装甲运输解决方案。" }
            ]
        },
        // Expensive Cargo
        // Heavy Cargo
        "title_17": "重型货物运输",
        "intro_17": {
            "main_text_17": "可靠专业的重型货物物流",
            "text_1": "MMSH 物流公司为超大型及重型货物（如工业机械、建筑设备、风力涡轮机和大型基础设施组件）提供定制化运输解决方案。我们在极端重量和尺寸要求的货物运输方面拥有专业经验，确保每一次运输都安全精确。我们采用专业平板拖车、低载货车、模块化运输系统和重型起重船，确保货物高效安全运输。我们的物流规划包括详细的路线分析、法规合规管理以及超限货物的护送协调。无论是跨境重型货运还是大规模工业项目，我们都能确保顺畅、高效、成本优化的运输服务。"
        },
        "projects_17": {
            "title": "重型货物物流的进展",
            "items": [
            { "title": "扩展专业重型运输车队。" },
            { "title": "AI 驱动的超限货物路线优化。" },
            { "title": "集成实时跟踪系统，用于工业机械运输。" },
            { "title": "优化大规模货物运输的物流方案。" }
            ]
        },
        "completed_projects_17": {
            "title": "已完成的项目",
            "items": [
            { "title": "开发超大型货物运输的多式联运解决方案。" },
            { "title": "成功执行国际重型机械运输任务。" }
            ]
        },
        // Heavy Cargo
        // Liquid Cargo
        "title_18": "液体货物运输",
        "intro_18": {
            "main_text_18": "专业安全的液体货物物流",
            "text_1": "MMSH 物流公司提供安全高效的液体货物运输解决方案，包括石油产品、化学品、食品级液体和工业流体。液体运输需要专业罐车、温控存储以及严格的法规合规管理。我们的车队包括专用 ISO 罐箱、柔性罐和散装液体运输船，确保运输的安全性和效率。通过实时监控系统、自动泄漏预防和先进的路线优化，我们确保安全且具有成本效益的交付。无论是运输危险化学品、食用油，还是药品级液体，我们的物流专家都能提供符合行业标准和环保法规的定制化运输解决方案。"
        },
        "projects_18": {
            "title": "液体货物物流的进展",
            "items": [
            { "title": "扩展食品级液体运输车队。" },
            { "title": "集成基于物联网的泄漏预防系统。" },
            { "title": "优化化学液体的多式联运方案。" },
            { "title": "开发环保液体货物存储解决方案。" }
            ]
        },
        "completed_projects_18": {
            "title": "已完成的项目",
            "items": [
            { "title": "建立石油产品的安全快速运输路线。" },
            { "title": "成功实施液体货物运输的实时监控系统。" }
            ]
        },
        // Liquid Cargo
        // Passenger Cars
        "title_19": "乘用车运输",
        "intro_19": {
            "main_text_19": "高效安全的乘用车物流运输",
            "text_1": "MMSH 物流公司专注于乘用车的安全高效运输，包括豪华汽车、电动车 (EVs) 和商用车队。我们综合的物流网络确保汽车能够通过公路、铁路、海运和空运无缝运输，为制造商、经销商和私人客户提供服务。我们为高价值及经典汽车提供封闭式运输，确保免受环境损害。我们的多式联运解决方案优化成本，同时保持最高安全标准。实时 GPS 追踪、定制保险方案及专业车辆处理确保安全无忧的运输体验。无论是单车运输还是大规模车队搬运，MMSH 物流公司都能保证准时无损交付。"
        },
        "projects_19": {
            "title": "乘用车运输的进展",
            "items": [
            { "title": "扩展豪华汽车封闭运输车队。" },
            { "title": "集成 AI 路线优化系统提升汽车运输效率。" },
            { "title": "优化电动车的多式联运方案。" },
            { "title": "开发可持续车辆运输解决方案。" }
            ]
        },
        "completed_projects_19": {
            "title": "已完成的项目",
            "items": [
            { "title": "成功建立全球车辆运输物流网络。" },
            { "title": "集成 GPS 追踪，实现实时车辆运输监控。" }
            ]
        },
        // Passenger Cars
        // Reefer Cargo
        "title_20": "冷藏货物运输",
        "intro_20": {
            "main_text_20": "可靠且温控精确的冷藏货物物流",
            "text_1": "MMSH 物流公司专注于温度敏感货物的运输，包括新鲜农产品、乳制品、药品、海鲜和冷冻食品。我们的冷藏物流解决方案确保整个供应链的温度精确控制，保证产品从起点到终点的完整性。我们使用最先进的冷藏集装箱、冷库设施和气候控制卡车，以防止变质并确保符合食品安全和药品监管要求。借助 AI 驱动的温度监测、实时追踪和优化的多式联运方案，我们保证物流的高效性、可靠性和成本效益。无论是运输易腐食品还是医疗用品，我们的定制物流解决方案都符合最高质量标准。"
        },
        "projects_20": {
            "title": "冷藏货物运输的进展",
            "items": [
            { "title": "扩展冷藏运输车队以满足生鲜货物需求。" },
            { "title": "基于 AI 的温度监测系统优化医药物流。" },
            { "title": "优化冷冻和新鲜食品的多式联运解决方案。" },
            { "title": "开发节能型冷藏存储设施。" }
            ]
        },
        "completed_projects_20": {
            "title": "已完成的项目",
            "items": [
            { "title": "建立全球食品和医药货物冷链物流系统。" },
            { "title": "集成智能冷藏追踪，实现实时温度监控。" }
            ]
        },
        // Reefer Cargo
        // Drivers' Office
        "title_21": "司机办公室",
        "intro_21": {
            "main_text_21": "为专业司机提供奖励与支持的工作环境",
            "text_1": "在 MMSH 物流公司，我们深知司机是我们运营的核心。我们致力于提供专业、舒适和有回报的工作环境。我们的现代化车队、精心规划的路线和先进的物流技术确保每次行程的高效性和便利性。通过具有竞争力的薪资、职业发展机会和强大的支持体系，我们确保司机得到充分的关怀。无论您是经验丰富的司机还是希望加入物流行业，MMSH 物流公司都提供稳定、尊重和以司机为中心的工作文化。"
        },
        "texts_21": {
            "main": "MMSH 物流公司的主要优势",
            "mini_1": "舒适使用我们的服务",
            "mini_2": "与调度员快速沟通",
            "mini_3": "每天访问 200+ 新货运订单",
            "mini_4": "节省时间的自动调度系统",
            "mini_5": "实时通知减少装卸延误",
            "mini_6": "精准追踪防止争议",
            "mini_7": "个性化支付计划实现智能财务管理",
            "mini_8": "AI 路线优化降低成本"
        },
        // Payments
        "title_22": "支付服务",
        "intro_22": {
            "main_text_22": "为司机提供无缝透明的支付服务",
            "text_1": "在 MMSH 物流公司，我们优先考虑司机的财务稳定性和便利性。我们的先进会计和支付系统确保工资及时、准确且透明地发放，消除财务不确定性的压力。通过自动工资处理、清晰的文档管理和专门的支持团队，司机可以专注于他们的旅程，而无需担心行政问题。我们的流程保证准时付款、便捷的财务记录访问和无忧交易。我们不仅把司机视为员工，更将他们视为成功的重要合作伙伴。我们的高效、公平和安全的财务管理使我们成为物流行业专业人士的理想选择。"
        },
        // Movement
        "title_23": "行驶限制",
        "intro_23": {
            "main_text_23": "了解欧盟区域的行驶限制",
            "text_1": "在欧盟作为非欧盟公民驾驶和工作受到严格的行驶限制和法律要求。为了合法运营，司机必须遵守签证法规、公路运输法律和边境管控。对于非欧盟公民，欧洲签证（申根工作签证）是必要的，并可能需要额外的工作许可证。此外，环境法规、收费系统和欧盟驾驶时间限制都会影响跨境运输。MMSH 物流公司为司机提供签证申请、工作许可和交通法规合规的指导，确保顺畅运营，避免罚款。如有疑问，请联系我们的服务热线。"
        },
        // Movement
        // Fuels
        "title_24": "燃油卡",
        "intro_24": {
            "main_text_24": "MMSH 物流公司的燃油卡政策",
            "text_1": "在 MMSH 物流公司，我们理解长途运输中可能会出现突发情况。尽管我们鼓励所有司机独立管理燃油费用，但在紧急情况下，我们会提供燃油卡。这些情况包括司机因突发情况暂时无法支付燃油费用。燃油卡仅作为最后手段使用，并需要事先批准。我们的首要任务是在关键时刻支持司机，同时保持负责任的财务管理。如需燃油费用方面的帮助，请联系相关部门。"
        },
        // Business Ethics
        "title_25": "MMSH 公司的商业道德",
        "intro_25": {
            "main_text_25": "我们对诚信和负责任物流的承诺",
            "text_1": "在 MMSH 物流公司，诚信、责任和尊重构成了我们商业道德的基础。我们优先考虑运营的透明性，确保每笔交易和合作关系的公平性。我们对可持续性的承诺促使我们采用环保实践和高效物流解决方案，以减少对环境的影响。我们珍视客户和员工的信任，打造建立在相互尊重、多样性和包容性基础上的工作场所。通过坚持最高的道德标准，我们确保 MMSH 物流公司始终是行业内值得信赖的领导者，致力于可靠性、创新和长期成功。"
        },
        // Career
        "title_26": "MMSH 物流的职业发展",
        "intro_26": {
            "main_text_26": "在 MMSH 物流公司打造成功的职业生涯",
            "text_1": "在 MMSH 物流公司，我们相信成功的职业生涯建立在成长、创新和支持性环境的基础上。我们致力于为员工提供发展技能、职业晋升和对物流行业产生深远影响的机会。通过打造一个重视团队合作、创造力和持续学习的工作场所，我们确保每位团队成员都能获得所需资源和指导。凭借具有竞争力的福利、强大的道德基础和对未来的愿景，MMSH 物流公司是您成长职业生涯和塑造全球物流未来的理想之地。要了解更多信息，请搜索我们的空缺职位或实习机会。",
            "join_our_team": "加入我们的团队",
            "view_vacancies": "查看职位空缺",
            "apply_for_internship": "申请实习",
        },
        // Vacancies
        "title_27": "MMSH 物流的职业机会",
        "intro_27": {
            "main_text_27": "探索 MMSH 物流的职业机会",
            "text_1": "在 MMSH 物流公司，我们为寻求成长、创新和支持性环境的专业人士提供丰富的职业机会。我们致力于帮助员工发展技能、推动职业晋升，并对物流行业产生深远影响。我们的工作场所鼓励团队合作、创造力和持续学习，确保每位团队成员都能获得成功所需的资源和指导。",
            "vacancies": "查看职位空缺"
        },
        // Internship
        "title_28": "MMSH 物流的实习机会",
        "intro_28": {
            "main_text_28": "探索 MMSH 物流的实习机会",
            "text_1": "在 MMSH 物流公司，我们为寻求成长、创新和支持性环境的专业人士提供丰富的职业机会。我们致力于帮助员工发展技能、推动职业晋升，并对物流行业产生深远影响。我们的工作场所鼓励团队合作、创造力和持续学习，确保每位团队成员都能获得成功所需的资源和指导。"
        },
        "internship_benefits": {
            "main_title": "为什么选择 MMSH 物流公司实习？",
            "description": "在 MMSH 物流公司实习不仅仅是一次学习体验，更是进入国际物流行业的起点。无论您是学生、应届毕业生，还是希望获得行业经验的人，我们的实习计划都能提供实践培训、专业指导和真实的物流运营体验。",
            "benefits": {
            "experience": {
                "title": "实践行业经验",
                "description": "直接接触物流流程，包括供应链管理、货运代理、清关和国际贸易法规。"
            },
            "mentorship": {
                "title": "行业专家指导",
                "description": "与经验丰富的专业人士并肩工作，他们将指导您发展必要的技术和商业技能。"
            },
            "career_growth": {
                "title": "职业发展机会",
                "description": "我们的许多实习生最终成为正式员工，这使得实习成为物流行业长期职业生涯的跳板。"
            },
            "networking": {
                "title": "建立行业人脉",
                "description": "与行业领导者建立联系，参加商务会议，并建立能够塑造未来职业生涯的关系。"
            },
            "innovation": {
                "title": "创新学习环境",
                "description": "我们强调技术驱动的物流解决方案，让您有机会使用 AI 工具、自动化系统和数据分析技术。"
            },
            "personal_growth": {
                "title": "个人成长与技能发展",
                "description": "在快节奏的国际工作环境中，提高您的问题解决能力、沟通能力和批判性思维能力。"
            }
            },
            "conclusion": "在 MMSH 物流公司，我们不仅提供实习，更提供能够为全球物流行业做好准备的职业发展体验。今天就加入我们吧！"
        },
        // Internship
        // Locations
        "locations": {
            "city": "城市",
            "phone_number": "电话号码",
            "data": [
            { "country": "cn", "city": "阿拉山口, 中国", "phone": "+86 901 123 45 67" },
            { "country": "us", "city": "俄亥俄州, 美国", "phone": "+1 614 555 78 90" },
            { "country": "de", "city": "法兰克福, 德国", "phone": "+49 69 123 45 67" },
            { "country": "uz", "city": "安集延, 乌兹别克斯坦", "phone": "+998 74 456 78 90" },
            { "country": "tr", "city": "伊斯坦布尔, 土耳其", "phone": "+90 212 987 65 43" }
            ],
            "data2": [
            { "country": "jp", "city": "京都, 日本", "phone": "+81 75 234 56 78" },
            { "country": "it", "city": "米兰, 意大利", "phone": "+39 02 123 45 67" },
            { "country": "it", "city": "罗马, 意大利", "phone": "+39 06 789 01 23" },
            { "country": "ru", "city": "莫斯科, 俄罗斯", "phone": "+33 1 234 56 78" }, 
            { "country": "cn", "city": "深圳, 中国", "phone": "+86 901 234 56 78" }
            ]
        },
        // Consulting
        "consulting_title": "咨询服务",
        "consulting_heading": "可靠的物流合作伙伴",
        "consulting_description": "在当今快节奏的世界中，企业需要可靠、高效和创新的物流解决方案，以保持竞争优势。在 MMSH 物流公司，我们理解每一批货物不仅仅是商品——它代表着您的企业声誉、客户信任和增长潜力。因此，我们提供无缝、经济高效且技术驱动的物流服务，帮助企业轻松扩展至全球市场。凭借我们在国际运输领域的强大影响力，MMSH 物流公司确保企业能够获得顺畅、及时和无忧的交付解决方案。无论是进出口运营、供应链管理还是货运代理，我们的公司都能提供量身定制的物流策略，以优化您的业务效率并节省成本。",
        "contact_email": "info@mmshlogistics.com",
        "contact_phone": "+998 90 123 45 67",
        // Customs Services
        "customs_services_title": "海关服务",
        "customs_services_heading": "高效可靠的清关解决方案",
        "customs_services_description": "在 MMSH 物流公司，我们深知海关法规是国际贸易中最关键的环节之一。我们的海关服务确保清关流程顺畅无阻，使您的货物高效跨境流通。凭借我们的专业知识，企业可减少延误、降低成本，并完全符合全球贸易法规。无论是进口还是出口，MMSH 物流公司均提供量身定制的海关文件处理、税则归类、关税优化及法规合规方案。我们的专业团队与海关机构紧密合作，确保清关过程无缝衔接，帮助企业节省时间，避免不必要的复杂手续。",
        // Warehouse Services
        "warehouse_services_title": "仓储服务",
        "warehouse_services_heading": "安全高效的仓储解决方案",
        "warehouse_services_description": "在 MMSH 物流公司，我们提供一流的仓储服务，旨在优化您的供应链。我们的现代化存储设施提供安全、温控和高效的仓储解决方案，以满足企业的独特需求。无论是短期存储、长期库存管理还是交叉转运服务，我们的仓储设施均配备最新技术，以确保实时追踪和无缝运营。MMSH 物流公司专注于优化仓储运营、降低成本并提高交付速度。我们的专家团队确保您的货物得到精准处理，使您的企业运营顺利高效。",
        // Insurance
        "insurance_services_title": "货运保险服务",
        "insurance_services_heading": "全面的货运保险，确保最大安全保障",
        "insurance_services_description": "作为物流服务的重要组成部分，MMSH 物流公司为客户提供可靠的货运保险方案。我们的‘全风险’保险提供最便捷和安全的保障，确保货物在运输过程中得到全面保护。若发生不可预见情况，该保险政策可保证全额赔偿损失。",
        "insurance_services_providers": "MMSH 物流公司与领先的保险机构‘Inson’合作，为客户提供高质量的货运保险。通过‘Inson’，我们确保客户获得顶级保障，每票货运最高可获 €1,500,000 保险赔付。我们的保险方案提供完整的安全保障，并符合国际物流标准。",
        "insurance_services_coverage_heading": "保险保障选项",
        "insurance_services_coverage": "MMSH 物流公司提供以下条件的货运保险：‘全风险’保险：在货物完全损坏或遗失的情况下进行全额赔偿。‘有限保险’：针对特定事件造成的损失提供赔偿。",
        "insurance_services_rates_heading": "货运保险费率",
        "insurance_services_rates": "基本保险费率介于发票价值的 0.25% 至 0.35% 之间。最终费率取决于多种因素，包括货物价值、种类、包装、运输量、路线等。MMSH 物流公司为长期合作伙伴提供特别优惠的保险价格。通常，免赔额（不予赔偿损失）设为零，确保即使是最小损失也能获得全额补偿。",
        "insurance_services_damage_handling_heading": "货损处理流程",
        "insurance_services_damage_handling": "我们的专业保险团队负责货损检查、索赔文件收集，并与保险公司协调谈判。通过与‘Inson’保险公司合作，MMSH 物流公司确保客户无需担心货物安全问题，并能获得最高达 €1,500,000 的全额赔偿。",
        // Insurance
        "vehicle_types": {
            "title": "车辆类型",
            "description": "在海运运输中，MMSH 物流公司采用专门适配的集装箱类型，包括：",
            "items": [
              "各种尺寸的 ISO 集装箱",
              "用于超大、散装和松散货物的特殊集装箱",
              "用于运输液体货物的罐式集装箱",
              "用于易腐货物的冷藏集装箱",
              "用于运输车辆、小型货物和危险品的专用集装箱"
            ]
          },
          "capabilities": {
            "title": "我们的能力",
            "description": "MMSH 物流公司提供一系列专业的铁路运输服务，确保安全高效的交付。",
            "items": [
              "采用恒温车厢、等温车厢和冷藏车进行温控运输。",
              "运输车辆、机械和设备。",
              "高效铁路运输易腐货物。",
              "处理超过 120 立方米的大型轻质货物。",
              "使用加快列车进行长距离货物运输。"
            ],
            "final_note": "MMSH 物流公司致力于提供灵活、可靠且定制化的物流解决方案。"
          },
          "regulations": {
            "title": "法规/文件",
            "description": "海运货运受到许多国家和国际法律法规的监管。",
            "list": [
              { "title": "主要公约", "content": "在乌兹别克斯坦，海运遵循联合国公约。" },
              { "title": "国家立法", "content": "除了国际协议外，MMSH 物流公司还遵守乌兹别克斯坦的国家法律。" },
              { "title": "专业监督", "content": "MMSH 物流公司密切关注海运法规的变化。" },
              { "title": "文件管理", "content": "我们的团队提供端到端的文件处理支持，确保所有必要的运输文件齐全。" }
            ],
            "conclusion": "MMSH 物流公司专注于法律合规和卓越运营，确保每一批货物安全运输。"
          },
          "start": {
            "trucks": "卡车",
            "train": "火车",
            "boats": "船舶",
            "air": "空运",
            "multimodal": "多式联运",
            "collective": "集体运输"
          },
          "big": {
            "trucks": "我们的公司通过先进的车队确保快速可靠的货物交付。",
            "train": "我们利用铁路运输的优势实现高效货物配送。",
            "boats": "我们充分利用海运的力量进行大规模货物运输。",
            "air": "我们通过高效的空运服务确保快速交付。",
            "multimodal": "我们提供无缝衔接的多式联运解决方案。",
            "collective": "我们支持舒适高效的集体运输模式。"
          },
          "logo_text": "MMSH 物流公司",
          "about_mmsh": "MMSH 物流公司致力于为企业客户提供卓越、可靠和高效的物流服务。我们以高品质的服务保障无缝、安全的运输解决方案，满足各种业务需求。凭借我们经验丰富的团队、先进的技术以及对客户满意度的坚定承诺，我们优化供应链的每一个环节，降低成本，提高运营效率。在 MMSH 物流公司，您的成功就是我们的首要任务。",
          "career": "MMSH 物流的职业发展",
          "work": "加入 MMSH 物流公司，迈向无限机遇与创新的世界。",
          "Responsible": "负责",
          "Supportive": "支持",
          "Comfortable": "舒适",
          "responsible": "在 MMSH 物流公司，我们全面负责提供无缝物流解决方案。我们的团队确保及时、安全的货物运输，精准处理每一个细节。",
          "supportive": "我们倡导强有力的合作关系和持续支持。无论是国际货运还是本地运输，我们的专家始终准备协助并引导客户完成每一个步骤。",
          "comfortable": "通过用户友好的服务和高效的运营，我们让物流变得轻松无忧。我们的客户可以依靠我们顺畅的流程、透明的沟通和便捷的运输服务。",
          "SignUp": "立即注册",
          "Learn_more": "了解更多",
          "Search_more": "搜索更多",
          "Back_to_top": "返回顶部",
          "View_details": "查看详情",
          "loading": "加载中...",
          "regions": {
            "china_team_leader": "中国团队负责人",
            "central_asia_russia_team_leader": "中亚和俄罗斯团队负责人",
            "europe_team_leader": "欧洲团队负责人"
          },
          "names": {
            "abdulloh": "阿卜杜拉",
            "nuriddin": "努里丁",
            "ulugbek": "乌卢格别克"
          },
          "texts": {
            "trustworthy_company": "值得信赖的公司，拥有众多认证证书。",
            "shipping_with_trains": "我们还提供铁路运输服务。",
            "experienced_drivers": "经验丰富的司机随时为您提供帮助。"
          },
          "write": {
            "km": "92.41",
            "done": "12731",
            "routes": "975",
            "loaders": "3211",
            "drivers": "7445"
          },
          "write_2": {
            "km_text": "百万公里",
            "done_text": "已完成订单",
            "routes_text": "目标贸易路线",
            "loaders_text": "企业客户",
            "drivers_text": "可靠的承运商"
          },
          "write_3": {
            "more": "了解更多",
            "see_statistics": "查看统计数据",
            "learn_more": "了解更多",
            "see": "查看",
            "check": "检查"
          },
          "Special": {
            "Industry_Solutions": "行业解决方案",
            "Special_Loads": "特殊货物",
            "Learn_more": "了解更多"
          },
          "Career": {
            "make_career": "在 MMSH 建立职业发展",
            "text": "在 MMSH，专业人士可以在市场营销策略、销售管理、客户关系、活动策划和酒店管理等领域发展事业。该行业需要具备强大的沟通能力、领导力和组织技能，并注重建立客户关系和推动业务增长。",
            "learn_more": "了解更多"
          },
          "News": {
            "News_in_Company": "公司新闻",
            "Growth_in_MMSH": "MMSH 的成长",
            "MMSH_is": "MMSH 向有抱负的人开放",
            "News_of_MMSH": "MMSH 新闻",
            "learn_more": "了解更多",
            "show_less": "收起",
            "text_1": "MMSH 公司很高兴宣布新增一批先进卡车至车队。这些车辆配备了先进技术，确保提高效率、安全性和环保性。",
            "text_2": "MMSH 自豪地认可员工的奉献精神和专业技能，他们是公司成功的推动力。MMSH 专注于持续的职业发展，为团队提供培训机会，促进创新和卓越。",
            "full_text_1": "MMSH 物流公司继续在全球范围内扩展业务。新卡车将提高我们更快速和可靠地服务客户的能力。我们承诺在所有车队运营中保持高标准的安全性、可持续性和性能。",
            "full_text_2": "作为培养卓越文化的一部分，MMSH 自豪地为员工提供多种职业发展计划。从领导力研讨会到技术培训，我们支持团队成员的成长，以确保他们能够为我们的共同愿景做出贡献。"
          },
          "sections": {
            "mmsh": "MMSH",
            "transport": "运输",
            "industry_solutions": "行业解决方案",
            "special_loads": "特殊货物",
            "for_drivers": "司机专区",
            "contacts": "联系方式",
            "career": "职业发展"
          },
          "links": {
            "about_company": "关于公司",
            "history_mission": "历史与使命",
            "certificates": "认证证书",
            "trucks": "卡车",
            "trains": "火车",
            "ships": "船舶",
            "air": "航空运输",
            "multimodal": "多式联运",
            "chemicals": "化学品",
            "technology": "技术",
            "groceries": "食品杂货",
            "agriculture": "农产品",
            "construction": "建筑行业",
            "pharmaceuticals": "制药行业",
            "fashion": "时尚行业",
            "expensive": "贵重货物",
            "passenger_cars": "乘用车运输",
            "liquid_cargo": "液体货物",
            "bulk_cargo": "散装货物",
            "heavy_cargo": "重型货物",
            "reefer_cargo": "冷藏货物",
            "carriers_office": "承运商办公室",
            "payments": "付款方式",
            "movement_restrictions": "行驶限制",
            "fuel_cards": "燃油卡",
            "mmsh_offices": "MMSH 办公室",
            "contact_experts": "联系专家",
            "business_ethics": "商业道德",
            "career": "职业机会",
            "vacancies": "职位空缺",
            "internship": "实习机会"
          },
          "business_description": "MMSH 物流公司致力于满足客户和利益相关者多样化的需求、期望和业务目标。通过尖端技术、行业专业知识和以客户为中心的方法，我们确保全球市场的物流运营无缝高效。我们的定制解决方案解决复杂的供应链挑战，优化运输网络，提高运营效率。",
          "certifications": "认证证书",
          "certificate_description": "这些认证确保符合全球标准。",
          "associations": "行业协会",
          "associations_description": "MMSH 与物流、贸易和运输领域的领先组织合作，以确保国际市场的合规性和高效性。",
          "no_certificates": "暂无认证证书。",
          "no_associations": "暂无行业协会信息。",
          // Certificate List
        "certificates_list": [
            {
            "title": "MMSH 官方认证",
            "description": "此认证保证了高标准的质量、安全性和可持续性。它验证了我们的管理体系符合国际质量和环境标准。",
            "document": "official"
            },
            {
            "title": "GDP - 良好分销规范认证",
            "description": "确保药品的正确分销和处理。此认证确认了运输过程中的安全和卫生标准合规性。",
            "document": "proof"
            },
            {
            "title": "综合货运保险",
            "description": "在运输过程中保护货物免受损失、损坏或被盗。我们的保险覆盖范围确保国际物流业务的财务安全和风险管理。",
            "document": "insurance"
            },
            {
            "title": "TAPA - 运输资产保护协会认证",
            "description": "确保供应链安全和风险管理的证书。该认证被认可用于保护高价值货物，防止运输过程中被盗和篡改。",
            "document": "license"
            },
            {
            "title": "ATI.SU 认证 - 乌兹别克斯坦第一",
            "description": "供应链安全和风险管理认证，被公认为可防止高价值货物在运输过程中被盗或篡改。",
            "document": "license"
            },
            {
            "title": "ATI.SU 认证 - 乌兹别克斯坦前十强公司之一",
            "description": "供应链安全和风险管理认证，被公认为可防止高价值货物在运输过程中被盗或篡改。",
            "document": "license"
            }
        ],
        // Association List
        "associations_list": [
            "FPAL - 自 FPAL 成立以来，它帮助英国石油和天然气行业的运营商促进合同成功交付并提高业务绩效。",
            "EIC - 英国能源行业委员会，支持全球能源供应链在物流和合规方面的发展。",
            "NCBFAA - 美国国家报关代理和货运代理协会，确保遵守国际货运法规。",
            "FIATA - 国际货运代理联合会，连接全球物流供应商。",
            "AIFFU - 乌克兰国际货运代理协会，加强东欧的运输关系。",
            "ZMPD - 波兰国际公路运输承运商协会，优化欧洲和中国之间的物流路线。",
            "TAPA - 运输资产保护协会，为供应链安全提供安全协议。",
            "BVL - 德国联邦物流协会，推动欧盟范围内可持续物流解决方案的发展。",
            "TIACA - 国际航空货运协会，联合全球航空货运运营商。",
            "BRITA - 一带一路国际运输联盟，促进中国和欧洲之间的无缝运输连接。",
            "LANDBRIDGE - 陆桥物流联盟，支持中欧之间的跨欧亚运输和清关。"
        ],
        // Additional paragraph descriptions for associations
        "associations_paragraphs": [
            "MMSH 积极与顶级物流组织合作，以确保全球贸易的高效性。我们在中国和欧洲的合作伙伴关系使我们能够优化海关、仓储和最后一公里配送。",
            "通过加入主要物流联盟，MMSH 确保无缝供应链解决方案，符合国际贸易法规和安全标准。",
            "MMSH 在中国“一带一路”倡议中的强大影响力，使我们能够为欧洲合作伙伴优化物流路线，确保更快、更具成本效益的货运运输。",
            "我们与欧洲物流联合会的合作，使我们能够保持符合欧盟运输法律的要求，提高跨境运输流程。"
        ],
        // Sidebar
        "home": "首页",
        "orders": "订单",
        "messages": "消息",
        "profile": "个人资料",
        "contacts": "联系方式",
        "home_desc": "返回首页",
        "orders_desc": "查看货运订单",
        "messages_desc": "查看您的消息",
        "profile_desc": "查看您的个人资料",
        "contacts_desc": "查找联系信息",
        // Login
        "login_title": "员工登录",
        "username": "用户名",
        "password": "密码",
        "login_btn": "登录",
        "footer_text": "© 2025 MMSH 公司",
        "error_required": "用户名和密码为必填项",
        // Login
            // Code Verify
            "success": "成功",
            "success_message": "您已成功注册为员工。",
            "return_btn": "返回",
            // Wrong
            "error": "错误",
            "error_message": "抱歉，您不是员工。",
            "retry_btn": "重试",
            // Profile
            "welcome": "欢迎, {{username}}!",
            "profile_message": "很高兴在 MMSH 见到您 😇",
            "logout": "退出",
            "Details": "详细信息",
            // Experts
            "experts": {
              "john_doe": {
                "name": "Ravshanbek Ahmadjonov",
                "expertise": "铁路物流",
                "mission": "欧洲高价值货运专家。"
              },
              "jane_smith": {
                "name": "Oyatillo Xamidjanov",
                "expertise": "货运与运输",
                "mission": "确保中美之间顺畅贸易的专业货运经理。"
              },
              "michael_lee": {
                "name": "Chirmashev Bekzod",
                "expertise": "董事",
                "mission": "国际贸易关系专家。"
              },
              "sophia_brown": {
                "name": "Oyqiz Mo'minova",
                "expertise": "国际航运",
                "mission": "中国至欧洲超大货物运输的领导者。"
              },
              "liam_garcia": {
                "name": "Guli Adhamjonova",
                "expertise": "海关与合规",
                "mission": "欧洲高价值货物海关法规专家。"
              },
              "olivia_martinez": {
                "name": "Zuhra Qudratillayeva",
                "expertise": "仓储运营",
                "mission": "美国大型配送中心仓库自动化战略专家。"
              },
              "william_harris": {
                "name": "Kuldashev Bahodirjon",
                "expertise": "冷链物流",
                "mission": "德国市场制药冷链物流专家。"
              },
              "emma_wilson": {
                "name": "Sardor Husanboyev",
                "expertise": "美国最后一公里配送",
                "mission": "美国快速最后一公里配送解决方案的领导专家。"
              },
              "ethan_carter": {
                "name": "Abdurahmonov Kamronbek",
                "expertise": "欧洲物流",
                "mission": "在美俄之间管理跨境货运的资深物流专家。"
              },
              "ava_robinson": {
                "name": "Abbosbek Munavvarov",
                "expertise": "俄罗斯物流",
                "mission": "专注于欧洲快递配送的专业物流经理。"
              },
              "noah_adams": {
                "name": "Ismoilov Asilbek",
                "expertise": "物流与供应链",
                "mission": "优化中欧物流流动的高级策略师。"
              },
              "isabella_thompson": {
                "name": "Ibrohimjon Mavlonov",
                "expertise": "货运与运输",
                "mission": "中国至德国的洲际铁路货运专家。"
              },
              "lucas_white": {
                "name": "Ulug'bek Olimov",
                "expertise": "车队管理",
                "mission": "专注于美国电动卡车采用的车队运营专家。"
              },
              "mia_johnson": {
                "name": "Farrux Xayitov",
                "expertise": "国际航运",
                "mission": "减少欧洲主要港口运输延误的专家。"
              },
              "benjamin_hall": {
                "name": "Zaynobidin Kamoldinov",
                "expertise": "经理",
                "mission": "中欧贸易关税谈判与合规专家。"
              },
              ibrohimjon: {
                name: "伊布罗希姆琼·伊萨科夫",
                expertise: "管理发展",
                mission: "在俄罗斯、土耳其和欧洲进行管理发展"
              },
              doniyor: {
                name: "多尼约尔·朱拉耶夫",
                expertise: "运输经理",
                mission: "负责与俄罗斯、白俄罗斯和中亚的贸易"
              },
              "Hide_Contact": "隐藏联系方式",
              "Contact": "联系",
              "Contact_with_Experts": "联系专家"
            },
            // Footer
            "quick_links": "快速链接",
            "about": "关于",
            "contact": "联系方式",
            "news": "新闻",
            "certificates": "证书",
            "resources": "资源",
            "blog": "博客",
            "careers": "职业",
            "support": "支持",
            "business_ethics": "商业道德",
            "register_as_staff": "注册为员工",
            "staff_only": "仅限注册成员",
            "staff": "员工",
            "all_rights_reserved": "版权所有。",    
        // Footer
            // Cargo types
            "cargo_types": {
              "title": "货物类型",
              "description": "MMSH 物流公司为各种类型的货物提供卓越的服务，确保全球范围内安全、高效和及时的运输。",
              "items": [
                "散装货物 - 高效运输大批量无包装货物。",
                "液体货物 - 安全处理和运输液体及化学品。",
                "冷藏货物 - 为易腐货物提供温控运输。",
                "集装箱货物 - 在标准化集装箱中安全运输。",
                "危险货物 - 为危险和受监管材料提供专业物流解决方案。",
                "项目货物 - 针对超大件和复杂货运提供定制方案。",
                "普通货物 - 可靠运输标准商品和商品货物。"
              ]
            },
            "header": {
              "Andijon": "安集延",
              "Alashankou": "阿拉山口",
              "Tashkent": "塔什干"
            },
            "advantages": {
              "title": "我们的优势",
              "experience": {
                "title": "经验",
                "description": "MMSH 物流公司在铁路运输领域拥有超过 17 年的经验……"
              },
              "safety": {
                "title": "安全性",
                "description": "我们的专家确保货物在运输过程中的安全性和完整性……"
              },
              "comprehensiveness": {
                "title": "全面性",
                "description": "除了运输服务外，MMSH 物流公司还提供仓储……"
              },
              "insurance": {
                "title": "保险",
                "description": "MMSH 运输的每件货物均享有最高 3,000,000 欧元的保险……"
              }
            },
            "map": "我们的地理覆盖范围",
            // Sidebar Products
            "submission_failed": "提交失败。请重试。",
            "fill_form_specialist": "填写表单以联系专家。",
            "your_question": "您的问题",
            "your_name": "您的姓名",
            "your_email": "您的电子邮件",
            "next": "下一步",
            "submitting": "提交中……",
            "submit": "提交",
            "thank_you": "谢谢！调度员将很快与您联系。",
            "logistics_solutions": "物流解决方案",
            "trucks": "卡车 »",
            "trains": "火车 »",
            "ships": "船舶 »",
            "air": "空运 »",
            "multimodal": "多式联运 »",
            "additional_services": "附加服务",
            "consulting": "咨询 »",
            "customs_services": "海关服务 »",
            "insurance": "保险 »",
            "project_logistics": "项目物流 »",
            "warehouse_services": "仓储服务 »",
            // Request for cargo transportation
            "request": "货运请求",
            "form": {
              "aboutCompany": "关于您的公司",
              "companyName": "公司名称",
              "companyAddress": "公司地址",
              "contactInfo": "联系信息",
              "contactName": "联系人姓名",
              "contactSurname": "联系人姓氏",
              "contactPhone": "联系电话",
              "email": "电子邮件",
              "cargoDetails": "货物详情",
              "fromCountry": "选择起始国家",
              "toCountry": "选择目的国家",
              "cargoType": "货物类型",
              "description": "描述",
              "privacyPolicy": "填写此表格即表示我确认同意隐私政策。",
              "promotions": "我同意通过电子邮件接收 MMSH 的新闻、优惠和促销信息。",
              "send": "发送",
              "sending": "发送中……",
              "success": "表单提交成功！",
              "error": "提交表单失败。"
            },
            "succes": "您已成功请求货物运输。调度员将很快与您联系。",
            // Check cargoes
            "loading_cargo": "加载中……",
            "errorFetchingCargo": "获取货运请求时出错。",
            "cargoRequests": "货运请求",
            "cargoType": "货物类型",
            "viewDetails": "查看详情",
            // Check cargo details
            "cargo_details": "您确定要删除此货运请求吗？",
            "Cargo_Details": "货物详情",
            "company_name": "公司名称",
            "company_address": "公司地址",
            "contact_name": "联系人姓名",
            "contact_phone_detail": "联系电话",
            "email": "电子邮件",
            "cargo_type": "货物类型",
            "description": "描述",
            "agree_privacy_policy": "同意隐私政策",
            "agree_promotions": "同意接收促销信息",
            "save_changes": "保存更改",
            "cancel": "取消",
            "yes": "是",
            "no": "否",
            "delete_cargo": "删除货物",
            "edit_cargo_details": "编辑货物详情",
            // Vacancies
            "career_opportunities": "MMSH 的职业机会",
            "vacancies": "职位空缺",
            "explore_opportunities": "探索令人兴奋的机会。",
            "search_vacancies": "搜索职位……",
            "vacancy": "职位",
            "audience": "受众",
            "job_category": "职位类别",
            "location": "地点",
            "active": "活跃",
            "not_active": "未激活",
            "no_vacancies": "未找到职位空缺",  
          // ChatBot
        "ask": "询问 MMSH",
        "sorry": "对不起，我无法理解您的问题。",
        // About page
        "header_title": "安全、进取、高效的航运公司。",
        "header_description": "MMSH 物流公司是一家可靠高效的航运公司，致力于提供安全且创新的运输解决方案。",
        "about_company": "关于公司",
        "read_more": "阅读更多",
        "read_less": "收起",
        "quality": "质量",
        "quality_short": "MMSH 物流公司确保高质量、安全和高效的货运服务。",
        "quality_full": "在 MMSH 物流公司，质量控制是我们的核心要素。我们执行严格的标准并持续监测，以确保每一批货物都能被精准、安全地处理。从包装到交付，我们的专业团队确保每个流程都符合最高质量标准，保障客户的货物安全高效运输。",
        "caring_nature": "环保责任",
        "caring_nature_short": "我们在运营的各个方面都优先考虑可持续性和环保实践。",
        "caring_nature_full": "MMSH 物流公司致力于可持续发展。我们在整个运营过程中采用环保措施，从减少碳排放到优化资源利用。我们的绿色物流战略不仅提升了效率，还为更清洁的环境做出贡献，同时确保为客户提供高效可靠的服务。",
        "assistance": "客户支持",
        "assistance_short": "简要介绍此博客文章。",
        "assistance_full": "MMSH 物流公司自豪地成为客户值得信赖的合作伙伴。从运输规划到交付，我们的团队始终提供可靠支持。我们根据每位客户的独特需求提供定制化解决方案，确保顺畅无忧的服务体验。",
        "innovations": "创新",
        "innovations_short": "我们的公司对新想法持开放态度。",
        "innovations_full": "MMSH 物流公司将创新作为运营核心。我们不断探索新技术和解决方案，以提升效率、减少环境影响，并拓展我们的服务范围。",
        "associations_about": "合作关系",
        "associations_short": "MMSH 物流公司与全球知名企业合作，提供一流的物流解决方案。",
        "associations_full": "MMSH 物流公司与世界知名企业紧密合作，为客户提供卓越的物流服务。我们的战略合作伙伴关系增强了全球业务覆盖范围，确保我们始终提供最前沿的运输解决方案。",
        "forward_thinking": "前瞻性思维",
        "forward_thinking_short": "我们的公司专注于增长、创新和全球扩张。",
        "forward_thinking_full": "我们的公司致力于长期增长和持续改进。展望未来，我们不断扩展业务，并投资于新技术，以提升我们的服务质量。",
        // Messages
        "fetch_error": "获取消息失败",
        "confirm_delete": "您确定要删除这条消息吗？",
        "delete_error": "删除消息失败",
        "delete_error_log": "删除消息时出错：",
        "question": "问题",
        "no_messages": "未找到消息。",
        // Contacts
        "Search_contacts": "搜索联系人...",
        "Contacts": "联系人",
        "Add_Contact": "添加联系人",
        "Please": "请不要共享联系人信息",
        "Save": "保存",
        "Username": "用户名",
        "Phone_1": "电话 1",
        "Phone_2": "电话 2（可选）",
        "edit": "编辑联系人",
        "delete": "删除联系人",     
        // History
        birth_title: "MMSH 物流的诞生",
        birth_text: "2019年，三位富有远见的兄弟——Minhojidin、MuhammadAli 和 Shukurillo——创立了 MMSH 物流公司。他们梦想建立一个连接世界各地企业的物流公司。",
        challenges_title: "挑战与坚持",
        challenges_text: "创建一家物流公司并不容易。他们面临着许多财务困难、运营障碍以及在竞争激烈的行业中建立信任的挑战。但他们的奉献精神和辛勤工作从未动摇。",
        expand_title: "拓展视野",
        expand_text: "尽管遇到了困难，MMSH 物流仍然迅速发展。通过建立战略合作伙伴关系并不断改进服务，他们开始与世界各地的企业合作。",
        global_title: "迈向全球",
        global_text: "如今，MMSH 物流与欧洲、亚洲及其他地区的 34 个国家建立了合作关系。他们的全球影响力证明了他们对卓越物流的承诺。",
        career_title: "创造职业机会",
        career_text: "MMSH 物流不仅仅是运输业务，它已成为年轻有才华的专业人士的成长平台，提供管理、市场营销、IT 和多语言沟通等职业机会。",
        future_title: "MMSH 物流的未来",
        future_text: "凭借创新、强大的领导力和对物流的热情，MMSH 物流持续增长。未来将带来更多扩展全球市场和技术革新的机会。",
        click_text: "点击这本书了解 MMSH 的历史",
        // History
                
    }
};

export default chn;